import Stickyfill from 'stickyfilljs'
import Headroom from "headroom.js";

const elements = $('.js-sticky');
Stickyfill.add(elements);


const header = $('#header')[0];
const headroom = new Headroom(header)

headroom.init()